export const parseRemoteOptions = (remoteOptions, extraProps = {}) => {
  return remoteOptions?.map(({ name, slug, ...rest }) => ({
    label: name,
    value: slug,
    ...rest,
    ...extraProps,
  }));
};
